import React from "react";
import { FormComponent } from "./FormComponent";
import { Control, FieldValues, useController } from "react-hook-form";
import { reactHookFormValidateType } from "../../types/common";

/* eslint @typescript-eslint/no-explicit-any: "off" */
interface EmailFieldProps<T extends FieldValues> {
	classes?: string;
	control: Control<T>;
	id: string;
	inputClasses?: string;
	label: string;
	name: string;
	onInputChange?: (name: string, value: string) => void;
	placeholder?: string;
	required?: boolean;
	validate?: reactHookFormValidateType;
}

export function EmailField({
	classes,
	control,
	id,
	inputClasses,
	label,
	name,
	onInputChange,
	placeholder,
	required = false,
	validate,
}: EmailFieldProps<any>) {
	const pattern =
		/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name,
		control,
		rules: {
			required,
			validate,
			pattern,
		},
	});
	const component = { id, name, label, required, errors, classes };

	const handleChange = (value: string) => {
		onInputChange && onInputChange(name, value);
		onChange(value);
	};

	return (
		<FormComponent {...component}>
			<input
				autoComplete="email"
				type="email"
				id={id}
				className={inputClasses}
				placeholder={placeholder}
				onChange={(e) => handleChange(e.target.value)}
				value={value || ""}
			/>
		</FormComponent>
	);
}
